import { render, staticRenderFns } from "./modular-lander-template.vue?vue&type=template&id=67400f0d&"
import script from "./modular-lander-template.vue?vue&type=script&lang=js&"
export * from "./modular-lander-template.vue?vue&type=script&lang=js&"
import style0 from "./modular-lander-template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,RichText: require('/usr/src/app/components/product-new/rich-text.vue').default,IconBoxes: require('/usr/src/app/components/modular-lander/icon-boxes.vue').default,ImageAndText: require('/usr/src/app/components/modular-lander/image-and-text.vue').default,TwoColLayout: require('/usr/src/app/components/modular-lander/two-col-layout.vue').default,CompliancePackages: require('/usr/src/app/components/modular-lander/compliance-packages.vue').default,StatesTable: require('/usr/src/app/components/product-new/states-table.vue').default,Faqs: require('/usr/src/app/components/product-new/faqs.vue').default,LlcSteps: require('/usr/src/app/components/business-formation/llc-steps.vue').default,StepsNew: require('/usr/src/app/components/product-new/steps-new.vue').default,StatesTablePersonalized: require('/usr/src/app/components/product-new/states-table-personalized.vue').default})
